import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoginHeader from "../header/LoginHeader";
import LoginForm from "../user/LoginForm";
// import useLiff from "../../hooks/useLiff";
import liff from "@line/liff";
import { useLiffProfile } from "../../context/LiffProfileContext";
import { readTouchUTM } from "../../utils/utm"; // ต้องมีฟังก์ชันนี้จริง

const useLiffAuth = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [liffReady, setLiffReady] = useState(false);

  useEffect(() => {
    const initLiff = async () => {
      try {
        await liff.init({ liffId: process.env.REACT_APP_LIFF_ID });
        setLiffReady(true);
        //console.log("Is logged in?", liff.isLoggedIn());
        /* if (!liff.isLoggedIn()) {
          liff.login({
            redirectUri: window.location.href,
            state: window.location.href,
          });
        }*/
        if (!liff.isLoggedIn()) {
          const isInLineApp = /Line/i.test(navigator.userAgent);

          if (isInLineApp) {
            // ถ้าเปิดใน LINE App → ใช้ liff.login ตามปกติ
            liff.login({
              redirectUri: window.location.href,
              state: window.location.href,
            });
          } else {
            
            // ถ้าเปิดจาก Chrome/Safari → redirect ไปเปิด LINE App ผ่าน URL
            if (process.env.REACT_APP_ENV === "prod") {
              const liffUrl = encodeURIComponent(window.location.href);
              const fullPath = window.location.pathname + window.location.search + window.location.hash;
              window.location.href = `line://app/${process.env.REACT_APP_LIFF_ID}?liff.state=${encodeURIComponent(fullPath)}`;


              // ส่งไปหน้า "open in LINE" แทน
              //window.location.href = `https://line.me/R/app/${process.env.REACT_APP_LIFF_ID}?liff.state=${encodeURIComponent(fullPath)}`;
              //line://app/1475405337-K7LoyXmB
              //console.log(`https://line.me/R/app/${process.env.REACT_APP_LIFF_ID}?redirect_uri=${liffUrl}`);
              //window.location.href = `https://line.me/R/app/${process.env.REACT_APP_LIFF_ID}?redirect_uri=${liffUrl}`;
            } else {
              liff.login({
                redirectUri: window.location.href,
                state: window.location.href,
              });
            }
          }
        } else {
          const accessToken = liff.getAccessToken();
          if (accessToken) {
            localStorage.setItem("authToken", accessToken);
            setLoggedIn(true);
          }
        }
      } catch (error) {
        console.error("LIFF Initialization failed", error);
        setLiffReady(true); // ยังต้อง mark ready เพื่อไม่ให้ลูป
      }
    };

    initLiff();
  }, []);

  const handleLogin = () => {
    if (!liff.isLoggedIn()) {
      liff.login({
        redirectUri: window.location.href,
        state: window.location.href,
      });
    }
  };
  const handleLogout = () => {
    if (liff.isLoggedIn()) {
      liff.logout();
      localStorage.removeItem("authToken");
      setLoggedIn(false);
      window.location.href = "/"; // หรือเปลี่ยนเป็น path ที่คุณต้องการ
    }
  };

  return { loggedIn, liffReady, handleLogin, handleLogout };
};

const Login = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [lang, setLang] = useState(i18n.language);
  // const { profile, loggedIn, handleLogin, handleLogout } = useLiff();
  const { loggedIn } = useLiffAuth();
  const { authToken, userId } = useLiffProfile();

  // ✅ อ่าน UTM ไว้ข้างบน (อยู่ในสโคปของ component)
  const { utm_source = "", utm_medium = "" } = useMemo(
    () => readTouchUTM() || {},
    []
  );

  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language]);

  // ถ้าไม่มี history ก่อนหน้า ให้กลับไปหน้า Main
  /* useEffect(() => {
    console.log(window.history);
   // if (window.history.length <= 2) {
      // กรณีเข้า login โดยตรง เช่นจาก external link
      window.history.pushState({}, "", "/");
      navigate(-1); // ไปหน้า Main
    //}
  }, []);*/

  return (
    <div>
      <div className="w-full h-screen bg-secondary-background-gray">
        <LoginHeader />
        {/* debug ดูค่า UTM ได้ชัดๆ */}
        <div className="text-sm opacity-70">
          utm_source: <b>{utm_source || "-"}</b> | utm_medium:{" "}
          <b>{utm_medium || "-"}</b>
        </div>
      </div>
    </div>
  );
};

export default Login;
